import React, { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Chip, Menu, MenuItem } from '@mui/material';
import { Buttons } from '../../toolympus/components/primitives';
import { useProjectStates } from './useProjectStates';

interface Props {
  value: string | null | undefined;
  update?: (v: string | null | undefined) => void;
  condensed?: boolean;
  forStage?: boolean;
}

export const getContrastTextColorSimple = (hexColor?: string) => {
  if(!hexColor) {
    return "#000000";
  }
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? "#000000" : "#FFFFFF";
}

export const ProjectStateDisplay = (props: Props) => {
  const { value } = props;

  const projectStates = useProjectStates();

  const record = projectStates.byCode[value || "no"];

  const options = useMemo(() => {
    if(props.forStage) {
      return projectStates.records.filter(r => r.extra?.is_applicable_for_stage);  
    }
    return projectStates.records;

  }, [projectStates.records, props.forStage]);

  const [menuAnchor,setMenuAnchor] = useState<any>(null);

  if(!props.value) {
    return null;
  }

  return (<>
    {props.condensed
      ? <CondensedChip
          style={{ background: record?.extra?.color, color: getContrastTextColorSimple(record?.extra?.color) }}
          onClick={e => { if(props.update) { setMenuAnchor(e.target) }}}
          />
      : <Chip
          size="small"
          label={record?.label || "..."}
          sx={{ background: record?.extra?.color, color: getContrastTextColorSimple(record?.extra?.color) }}
          onClick={e => { if(props.update) { setMenuAnchor(e.target) }}}
          />}

    {!!menuAnchor &&
      <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={() => setMenuAnchor(null)}>
        {options?.map(r => (
          <MenuItem
            key={r.code}
            onClick={() => { props.update && props.update(r.code); setMenuAnchor(null); }}>
              <Buttons>
                <CondensedChip style={{ background: r?.extra?.color, color: getContrastTextColorSimple(record?.extra?.color) }} />
                {r.label}
              </Buttons>
          </MenuItem>
        ))}
      </Menu>}
    </>);
}


const CondensedChip = styled.span`
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
`;